
import { Options, Vue } from "vue-class-component";
import axios from "axios";
import ADDRESS from "@/settings";
import { useStore } from "vuex";
import CategoryItem from "@/components/CategoryItem.vue";

@Options({
  components: {CategoryItem},
})
export default class Aboutus extends Vue {
  store = useStore()
  doc: any = {};
  address = ADDRESS;
  categories: Array<any> = []
  page = 1;
  mounted() {
    this.fetchData();
    this.fetchCategory()
  }
  async fetchData() {
    let response = await axios.get(`${ADDRESS}/setting/get-by-name/aboutus`);
    this.doc = response.data.doc;
  }
  fetchCategory() {
    let query = {
      limit: 4,
      page: this.page,
      sort: { createdAt: -1 },
    };
    axios.post(`${ADDRESS}/categories/paginate`, query).then((response) => {
      console.log("result", response);
      this.categories = response.data.docs;
    });
  }
}
